import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconWifi(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.054 9.024a.667.667 0 0 1-.428-1.179 8 8 0 0 1 10.24 0 .666.666 0 1 1-.853 1.025 6.665 6.665 0 0 0-8.533 0 .67.67 0 0 1-.427.154zM.667 6.658a.666.666 0 0 1-.441-1.167c4.273-3.766 10.717-3.766 14.989 0a.666.666 0 1 1-.882 1c-3.77-3.322-9.456-3.322-13.225 0a.669.669 0 0 1-.441.167zm9.373 4.74a.664.664 0 0 1-.385-.123 3.339 3.339 0 0 0-3.862 0 .666.666 0 0 1-.772-1.086 4.672 4.672 0 0 1 5.406 0 .665.665 0 0 1-.387 1.21zm-2.32 2.593a.66.66 0 0 1-.473-.193c-.06-.067-.107-.14-.14-.22s-.053-.167-.053-.253a.7.7 0 0 1 .193-.473.673.673 0 0 1 .607-.18c.04.007.08.02.12.04a.48.48 0 0 1 .12.06c.033.02.067.053.1.08a.7.7 0 0 1 .193.473c0 .087-.02.173-.053.253s-.08.153-.14.22a.662.662 0 0 1-.473.193z"
  }));
}
IconWifi.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconWifi.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconWifi as default };
